"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemPlatformClipboard = void 0;
class MemBlob {
    constructor(data) {
        this.buf = typeof data === 'string' ? new TextEncoder().encode(data) : data;
    }
    async arrayBuffer() {
        return this.buf.buffer.slice(this.buf.byteOffset, this.buf.byteOffset + this.buf.byteLength);
    }
}
class MemClipboardItem {
    constructor(items) {
        this.data = {};
        const enc = new TextEncoder();
        for (const type in items) {
            const v = items[type];
            this.data[type] = typeof v === 'string' ? enc.encode(v) : v;
        }
        this.types = Object.keys(items);
    }
    async getType(type) {
        const buf = this.data[type];
        if (!buf)
            throw new DOMException(`Type ${type} not found`, 'NotFoundError');
        return new MemBlob(buf);
    }
}
class MemPlatformClipboard {
    constructor() {
        this.items = [];
    }
    async writeText(data) {
        this.items = [new MemClipboardItem({ 'text/plain': data })];
    }
    async write(data) {
        this.items = data;
    }
    async read() {
        return this.items;
    }
}
exports.MemPlatformClipboard = MemPlatformClipboard;
